<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link :to="`/layout/city-food?page=${page}`">驻京美食</router-link></li>
                <li class="currentNode"><a>美食详情</a></li>
            </ul>
            <div class="page-main">
                <h4>
                    <span>{{ title }}</span>
                    <span class="food-tag" v-for="tag in tagList" :key="tag">{{ tag }}</span>
                    <!-- <span class="food-tag">有包间</span> -->
                </h4>
               <div class="page-main-tp">
                    <img :src="imageUrl" />
                    <div class="brief-introduction">
                        <p class="food-price">{{ avgPrice }}<i> /人</i></p>
                        <el-divider></el-divider>
                        <p>营业时间：全年（周一至周日）全天：9:00-22:00</p>
                        <p>电话：{{ tel }}</p>
                        <p>地址：{{ homeAddress }} </p>
                    </div>
                </div>
                <div class="page-main-btm">
                    <h4>餐厅简介</h4>
                    <div class="restaurant-introduction">
                        <div class="restaurant-introduction-lf" v-html="description">
                        </div>
                        <div class="restaurant-introduction-rg">
                            <img v-for="homeImage in homeImageList" :src="homeImage" :key="homeImage" />
                        </div>
                    </div>
                    <h4>推荐菜</h4>
                    <div class="swipper-div">
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <swiper class="swiper" :options="swiperOption" ref="mySwiper">
                            <swiper-slide v-for="recommendation in recommendationList" :key="recommendation.ImageId">
                                <el-image
                                    :src="recommendation.ImageUrl"
                                    class="foodLogo"
                                    :preview-src-list="recommendation.ImageUrlList">
                                </el-image>
                                <!-- <img :src="recommendation.ImageUrl" class="foodLogo" @click="goCompanyDetail(vip)"/> -->
                                <p>{{ recommendation.Title }}</p>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getFoodShopDetail
} from '@services/indexService.js'
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
    name:"",
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            detailId: '',
            page: '',
            title: '',
            subTitle: '',
            tagList: [],
            createTime: '',
            imageUrl: '',
            tel: '',
            homeAddress:'',
            avgPrice: '',
            description: '',
            recommendationList: [],
            homeImageList: [],
            publishTime:'',
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 10,
                grabCursor: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        }
            },
            focusNews:{
                title: '',
                subTitle:'',
                id: '',
                type: '',
            }
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.page = this.$route.query.page;
        this.getFoodShopDetail(this.detailId);
    },
    mounted(){
    },
    methods: {
        getFoodShopDetail(id) {
            let params = {
                id: id
            };
            getFoodShopDetail(params).then(res => {
                console.log(res);
                if (res.Code === 1 && res.Data !== null && res.Data.length!==0) {
                    this.publishTime = res.Data.UpdateTime;
                    this.title = res.Data.Title;
                    this.subTitle = res.Data.SubTitle;
                    this.tagList = res.Data.lstSubTitle;
                    this.createTime = res.Data.CreateTime;
                    this.imageUrl = res.Data.ImageUrl;
                    this.tel = res.Data.Tel;
                    this.homeAddress = res.Data.HomeAddress;
                    this.avgPrice = res.Data.AvgPrice;
                    this.description = res.Data.Description;
                    this.recommendationList = res.Data.ListImage;
                    this.recommendationList.map(item => {
                        item.ImageUrlList= [item.ImageUrl];
                    })
                    this.homeImageList = res.Data.ListHomeImage;
                    this.initMap([res.Data.IsRecommend, res.Data.RecommendNum]);
                } else {
                    this.$message.error("协会要问请求失败");
                }
            })

        },
        initMap(location) {
            // 百度地图API功能
            var map = new BMap.Map("allmap");
            var point = new BMap.Point(location[0], location[1]);
            map.centerAndZoom(point, 15);
            var marker = new BMap.Marker(point);  // 创建标注
            map.addOverlay(marker);               // 将标注添加到地图中
            marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
            map.enableScrollWheelZoom(); //启用滚轮放大缩小，默认禁用
            map.enableContinuousZoom(); //启用地图惯性拖拽，默认禁用
        },
        prev(){
            console.log(this.$refs.mySwiper.swiper);
            this.$refs.mySwiper.swiper.slidePrev();
        },
        next() {
            this.$refs.mySwiper.swiper.slideNext();
        },
    }
}
</script>
<style src="../../assets/css/articleDetail.css" scoped></style>
<style scoped>
.page-main h4 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #262626;
    font-size: 26px;
    margin-bottom: 20px;
}
.page-main h4 span:first-child {
    margin-right: 10px;
}
.food-tag{
    background: #0090F0;
    font-size: 12px;
    color: #fff;
    padding: 2px 4px;
    margin-right: 10px;
}
.page-main-tp {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.page-main-tp img {
    width: 601px;
    height: 271px;
}
.brief-introduction {
    padding-left:30px;
    width: 601px;
    height: 271px;
    background: #F6F6F6;
    padding-top: 60px;
    box-sizing: border-box;
}
.brief-introduction h3{
    font-size: 26px;
    color: #262626;
    margin-bottom: 20px;
}
.brief-introduction  p {
    font-family: 思源黑体 CN;
    font-size: 14px;
    color: #6A6A6A;
    line-height: 26px;
}
.page-main-btm h4 {
    color: #262626;
    font-size: 22px;
    margin: 20px 0;
}
.page-main-btm p{
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    text-indent: 2em;
    white-space: pre-wrap; /* 保留空白符，但是正常换行 */
    text-indent: 0;       /* 初始化缩进为0 */
    margin-bottom:0;
}
.restaurant-introduction{
    padding: 30px;
    background: #F6F6F6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.restaurant-introduction-lf {
    width: 600px;
}
.restaurant-introduction-rg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 352px;
}
.restaurant-introduction-rg img{
    width: 164px;
    height: 200px;
    margin-bottom: 10px;
}
.recommendation-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.recommendation-item {
    padding-bottom: 20px;
    margin-right: 34px;
}
.recommendation-list .recommendation-item:nth-child(3n) {
    margin-right: 0px;
}
.recommendation-item img{
    width: 380px;
    height: 225px;
}
.recommendation-item p{
    font-size: 20px;
    color: #4E5969;
    text-align: center;
}

.map-div{
    width: 100%;
    margin: 0 auto;
    background: #F6F6F6;
    padding:30px;
    box-sizing: border-box;
}
#allmap {
    width: 100%;
    height:300px;
}
.swipper-div {
    position: relative;
    padding-top: 24px;
    display: flex;
    justify-content: space-between;
}
.swiper-button-prev,
.swiper-button-next {
    width: 30px !important;
    height: 112px !important;
    top: calc(50% - 50px);
    background-repeat: no-repeat;
}
.swiper-container {
    width: 920px;
}
.swiper-slide {
    height: 270px !important;
 }
 .swiper-slide .foodLogo {
    width: 300px;
    height: 225px;
    /* border: 1px solid #e5e5e5; */
    cursor: pointer;
}
.swiper-button-prev {
    background-image: url(../../assets/image/indexNew/arrow.png) !important;
    transform: rotate(180deg);
}
.swiper-button-next {
    background-image: url(../../assets/image/indexNew/arrow.png) !important;
}
.updateTime {
    padding-top: 20px;
}
.updateTime p{
    text-align:right;
}

</style>
<style>
 .BMap_cpyCtrl{
    display:none;
 }

</style>